import { createSlice } from '@reduxjs/toolkit';
import {
  addViewedProducts,
  fetchViewedProducts,
} from '../thunk/recently-viewed-thunk';

// Initial state
const initialState = {
  items: [],
  isLoading: false,
  error: null,
  page: 1,
  limit: 10,
};

// Slice
const recentlyViewedSlice = createSlice({
  name: 'recently-viewed',
  initialState,
  reducers: {
    reset: (state) => {
      state.items = [];
      state.isLoading = false;
      state.error = null;
      state.page = 1;
      state.limit = 12;
    },
    addToRecentlyViewed: (state, action) => {
      const currentList = state.items;
      let updatedList = null;
      if (action.payload) {
        if (action.payload?.id) {
          updatedList = currentList?.filter(
            (product) => product.id !== action.payload.id,
          );
        }
        updatedList.unshift(action.payload);
        state.items = updatedList;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchViewedProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchViewedProducts.fulfilled, (state, action) => {
        if (action.payload?.items?.length > 0) {
          state.items = action.payload?.items;
        }
        state.isLoading = false;
        state.error = null;
      })
      .addCase(fetchViewedProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(addViewedProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addViewedProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(addViewedProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { addToRecentlyViewed, reset } = recentlyViewedSlice.actions;

export default recentlyViewedSlice.reducer;
